"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * development API of Digital Villages Platform
 * See digitale-doerfer-api.json (info.description) for more details
 *
 * The version of the OpenAPI document: See digitale-doerfer-api.json
 * Contact: support@digitale-doerfer.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
const _1 = require("./");
function ClientPersonReferenceFromJSON(json) {
    return ClientPersonReferenceFromJSONTyped(json, false);
}
exports.ClientPersonReferenceFromJSON = ClientPersonReferenceFromJSON;
function ClientPersonReferenceFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'deleted': !runtime_1.exists(json, 'deleted') ? undefined : json['deleted'],
        'filterStatus': !runtime_1.exists(json, 'filterStatus') ? undefined : json['filterStatus'],
        'firstName': !runtime_1.exists(json, 'firstName') ? undefined : json['firstName'],
        'id': json['id'],
        'lastName': !runtime_1.exists(json, 'lastName') ? undefined : json['lastName'],
        'profilePicture': !runtime_1.exists(json, 'profilePicture') ? undefined : _1.ClientMediaItemFromJSON(json['profilePicture']),
        'status': !runtime_1.exists(json, 'status') ? undefined : json['status'],
    };
}
exports.ClientPersonReferenceFromJSONTyped = ClientPersonReferenceFromJSONTyped;
function ClientPersonReferenceToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'deleted': value.deleted,
        'filterStatus': value.filterStatus,
        'firstName': value.firstName,
        'id': value.id,
        'lastName': value.lastName,
        'profilePicture': _1.ClientMediaItemToJSON(value.profilePicture),
        'status': value.status,
    };
}
exports.ClientPersonReferenceToJSON = ClientPersonReferenceToJSON;
/**
* @export
* @enum {string}
*/
var ClientPersonReferenceFilterStatusEnum;
(function (ClientPersonReferenceFilterStatusEnum) {
    ClientPersonReferenceFilterStatusEnum["BLOCKED"] = "BLOCKED";
    ClientPersonReferenceFilterStatusEnum["FLAGGED"] = "FLAGGED";
})(ClientPersonReferenceFilterStatusEnum = exports.ClientPersonReferenceFilterStatusEnum || (exports.ClientPersonReferenceFilterStatusEnum = {}));
/**
* @export
* @enum {string}
*/
var ClientPersonReferenceStatusEnum;
(function (ClientPersonReferenceStatusEnum) {
    ClientPersonReferenceStatusEnum["REGISTERED"] = "REGISTERED";
    ClientPersonReferenceStatusEnum["DELETED"] = "DELETED";
})(ClientPersonReferenceStatusEnum = exports.ClientPersonReferenceStatusEnum || (exports.ClientPersonReferenceStatusEnum = {}));
